export default {"src":"/_next/static/media/0x50379f632ca68d36e50cfbc8f78fe16bd1499d1e.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};